import React from "react";
import { Input, Form } from "antd";
import { FormInstance } from "antd/es/form/Form";
import { FormListFieldData } from "antd/lib/form/FormList";
import { PlusOutlined, MinusCircleOutlined } from "assets/icons";
import { DrawerStatusEnum } from "typings/global.types";
import { charactersDocumentsValidation } from "utils/form/validations";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./index.styled";

export interface IAddInvoices {
  fields: FormListFieldData[];
  fieldsCount: number;
  disabled: boolean;
  allowLetters: boolean;
  allowNumbers: boolean;
  allowSpecialCharacters: boolean;
  isIntegration: boolean;
  required: number;
  minCharacters: number;
  maxCharacters: number;
  form: FormInstance;
  label: unknown;
  eventType: number;
  add: () => void;
  remove: (index: number) => void;
  setFieldsCount: React.Dispatch<React.SetStateAction<number>>;
  initialFields: number[];
  visibleDrawerViewMode?: DrawerStatusEnum;
}

const AddInvoices = ({
  fields,
  fieldsCount,
  add,
  remove,
  disabled,
  allowLetters,
  allowNumbers,
  allowSpecialCharacters,
  minCharacters,
  maxCharacters,
  required,
  eventType,
  isIntegration,
  initialFields,
  visibleDrawerViewMode,
}: IAddInvoices): JSX.Element => {
  const MINIMUM_LIMIT = useTranslation({ id: "minimum_limit_of" });
  const REQUIRED_FIELD = useTranslation({ id: "required_field" });
  const CARACTERS = useTranslation({ id: "caracters" });
  const isLastItem = (index: number) => index + 1 === fields.length;
  const inboundRequiredItem = [1, 3];
  const outboundRequiredItem = [2, 3];
  const inboundEventType = 1;
  const outboundEventType = 2;
  const checkRequiredItem = (requiredType: number) => {
    return (outboundEventType === eventType && outboundRequiredItem.includes(requiredType)) || (inboundEventType === eventType && inboundRequiredItem.includes(requiredType));
  };
  const isFieldDisabled = (fieldName: number) => {
    const checkFields = initialFields.includes(fieldName) && isIntegration;
    return checkFields;
  };

  return (
    <S.FormAddInvoices disabled={disabled} isIntegration={isIntegration} visibleDrawerViewMode={visibleDrawerViewMode} count={fieldsCount} className={disabled ? "disabled" : ""}>
      {fields.map((field, index) => {
        const isFieldInitiallyFilled = Array.isArray(initialFields) && initialFields.includes(field.name);
        return (
          <React.Fragment key={field.key}>
            <Form.Item
              {...field}
              validateTrigger={["onChange", "onBlur"]}
              hasFeedback
              rules={[
                {
                  required: checkRequiredItem(required),
                  message: REQUIRED_FIELD,
                },
                {
                  min: minCharacters,
                  message: `${MINIMUM_LIMIT} ${minCharacters} ${CARACTERS}`,
                },
              ]}
              className="GridItens"
            >
              <Input
                style={S.InvoicesField}
                data-testid="invoices"
                disabled={disabled || isFieldDisabled(field.name)}
                maxLength={maxCharacters}
                onKeyPress={(e) => charactersDocumentsValidation(e, allowLetters, allowNumbers, allowSpecialCharacters)}
              />
            </Form.Item>
            {fieldsCount > 1 && !disabled && !isFieldInitiallyFilled && (
              <S.RemoveButtonInvoice
                data-testid="remove-btn"
                onClick={() => remove(field.name)}
                style={S.InvoicesFieldIcon}
                icon={<MinusCircleOutlined className="removeButtonInvoices" />}
              />
            )}
            {fieldsCount > 1 && !disabled && isFieldInitiallyFilled && !isIntegration && (
              <S.RemoveButtonInvoice
                data-testid="remove-btn"
                onClick={() => remove(field.name)}
                style={S.InvoicesFieldIcon}
                icon={<MinusCircleOutlined className="removeButtonInvoices" />}
              />
            )}
            {isLastItem(index) && !disabled && !isFieldDisabled(field.name) && (
              <>
                {fieldsCount > 1 && <div></div>}
                <S.AddButtonInvoice data-testid="add-btn" disabled={disabled} onClick={add} icon={<PlusOutlined className="addButtonInvoices" style={S.InvoicesFieldIcon} />} />
              </>
            )}
            {!isLastItem(index) && isFieldDisabled(field.name) && DrawerStatusEnum.Edit === visibleDrawerViewMode && <>{fieldsCount >= 1 && <div></div>}</>}
            {isLastItem(index) && isFieldDisabled(field.name) && DrawerStatusEnum.Edit === visibleDrawerViewMode && (
              <S.AddButtonInvoice data-testid="add-btn" disabled={disabled} onClick={add} icon={<PlusOutlined className="addButtonInvoices" style={S.InvoicesFieldIcon} />} />
            )}
          </React.Fragment>
        );
      })}
    </S.FormAddInvoices>
  );
};

export default AddInvoices;
